import React from 'react'; //eslint-disable-line no-unused-vars
import {Switch, Route} from 'react-router-dom';
import ErrorView from '../pages/error/ErrorView';
import {appRoutes} from '@epic-core/utils';
import {getRouteDefinitions, redirectLocale} from 'epic-diesel-common/src/routes/Routes';
import '../Plugins';

export const getRoutes = (routeDefinition, location) => {
    const routes = appRoutes(routeDefinition);
    const locationObj = typeof location.toJS === 'function' ? location.toJS() : location;
    const routeSwitch = (
        <Switch location={locationObj}>
            {routes.map(pluginComponent => {
                return <Route key={pluginComponent.key} {...pluginComponent} />;
            })}
        </Switch>
    );
    return routeSwitch;
};

export default function getAppRoutes() {
    return [
        {path: '', exact: true, render: redirectLocale.bind(null, '/overview')},
        {path: 'home', exact: true, render: redirectLocale.bind(null, '/overview')},
        {
            // Redirection on logged out when session expired
            path: `fortnite-games/overview`,
            exact: true,
            render: redirectLocale.bind(null, '/overview')
        },
        {
            // Redirection on logged out when session expired
            path: 'news/overview',
            exact: true,
            render: redirectLocale.bind(null, '/overview')
        },
        {
            path: 'blog/:slug',
            exact: true,
            render: redirectLocale.bind(
                null,
                // The :slug param is used to redirect to a news article with the same slug
                ({slug}) => `/news/${slug}`
            )
        },
        ...getRouteDefinitions(),
        {path: 'unexpected-error', exact: true, render: () => <ErrorView status={500} />},
        {path: '*', render: () => <ErrorView status={404} />}
    ]; // Concat app routes with routes defined as part of plugin provider
}
